import React, { useId } from 'react';
import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  showTier?: boolean;
  tierName?: string | null;
}

interface DiscloserMarkProps {
  size?: number;
  fill?: string;
  className?: string;
}

export function DiscloserMark({
  size = 28,
  fill = 'hsl(var(--brand-ink))',
  className,
}: DiscloserMarkProps) {
  const maskId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      aria-label="Discloser"
      className={className}
    >
      <defs>
        <mask id={maskId} maskUnits="userSpaceOnUse">
          <rect width="64" height="64" fill="white" />
          <polygon points="26,56 36,56 36,42 26,42" fill="black" />
          <polygon points="38,38 46,38 46,30 38,30" fill="black" />
        </mask>
      </defs>
      <g mask={`url(#${maskId})`}>
        <polygon points="10,56 50,56 50,22 10,22" fill={fill} />
        <polygon points="10,22 50,22 56,16 16,16" fill={fill} opacity="0.78" />
        <polygon points="50,56 56,52 56,16 50,22" fill={fill} opacity="0.55" />
      </g>
    </svg>
  );
}

export const Logo = ({ className, showTier, tierName }: LogoProps) => {
  return (
    <div className={cn('inline-flex items-center gap-2', className)}>
      <DiscloserMark size={36} />
      <span className="font-display text-3xl md:text-4xl font-semibold leading-none tracking-tight text-brand-ink">
        Discloser
      </span>

      {showTier && tierName && (
        <sup className="text-xs md:text-sm font-bold text-gray-500 leading-none -mt-4 md:-mt-5 ml-1">
          {tierName}
        </sup>
      )}
    </div>
  );
};
